import { render, staticRenderFns } from "./TabellaRichieste.vue?vue&type=template&id=024dcb55&scoped=true&"
import script from "./TabellaRichieste.vue?vue&type=script&lang=js&"
export * from "./TabellaRichieste.vue?vue&type=script&lang=js&"
import style0 from "./TabellaRichieste.vue?vue&type=style&index=0&id=024dcb55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024dcb55",
  null
  
)

export default component.exports